module.exports = __webpack_public_path__ + "static/media/clock-time-watch-svgrepo-com.06834a7e.svg";